(function () {
  'use strict';

  const body = document.body;
  const RECENT_KEY = 'bb_recent_viewed';
  const WISHLIST_KEY = 'bb_wishlist';
  const COUPON_KEY = 'bb_discount_code';
  const SEARCH_SYNONYMS = {
    raspi: 'raspberry pi',
    uno: 'arduino uno'
  };

  let cartData = { items: [], item_count: 0, total_price: 0 };
  let wishlistSyncInFlight = false;

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncementBar();
    initNav();
    initScrollTop();
    initImageZoom();
    initReveal();
    initCategoryFilter();
    initSearch();
    initCart();
    initCartButtons();
    initWishlist();
    initProductPage();
    initThumbnails();
    initMobileSearchToggle();
    initRecentlyViewed();
    initCopyButtons();
    initRecommendations();
    initViewToggle();
    initScrollRows();
  });

  function getNumber(value, fallback = 0) {
    const parsed = parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function formatMoney(cents) {
    const rupees = (Number(cents) || 0) / 100;
    return `₹${new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0
    }).format(rupees)}`;
  }

  function formatRupees(value) {
    return `₹${new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0
    }).format(Number(value) || 0)}`;
  }

  function lockBody(locked) {
    body.classList.toggle('body-locked', locked);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);
  }

  function showToast(message, type = 'success') {
    let container = document.getElementById('toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.textContent = message;
    container.appendChild(toast);

    requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('show')));

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 260);
    }, 2800);
  }

  function initAnnouncementBar() {
    const items = document.querySelectorAll('.announcement-item');
    if (items.length <= 1) return;

    let index = 0;
    window.setInterval(() => {
      items[index].classList.remove('active');
      index = (index + 1) % items.length;
      items[index].classList.add('active');
    }, 3800);
  }

  function initCopyButtons() {
    document.querySelectorAll('[data-copy-coupon]').forEach(button => {
      button.addEventListener('click', async () => {
        const code = button.dataset.copyCoupon;
        if (!code) return;

        try {
          await navigator.clipboard.writeText(code);
          sessionStorage.setItem(COUPON_KEY, code);
          showToast(`${code} copied`, 'success');
        } catch (error) {
          showToast(`Use coupon ${code}`, 'info');
        }
      });
    });
  }

  function initNav() {
    const hamburger = document.getElementById('hamburger');
    const nav = document.getElementById('nav');
    const navClose = document.getElementById('nav-close');
    const overlay = document.getElementById('nav-overlay');
    if (!hamburger || !nav) return;

    const open = () => {
      nav.classList.add('active');
      hamburger.classList.add('active');
      if (overlay) overlay.classList.add('active');
      body.classList.add('menu-open');
      lockBody(true);
    };

    const close = () => {
      nav.classList.remove('active');
      hamburger.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      body.classList.remove('menu-open');
      lockBody(false);
    };

    hamburger.addEventListener('click', open);
    if (navClose) navClose.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && nav.classList.contains('active')) close();
    });
  }

  function initReveal() {
    const elements = document.querySelectorAll('.reveal');
    if (!elements.length || !('IntersectionObserver' in window)) {
      elements.forEach(element => element.classList.add('visible'));
      return;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    elements.forEach(element => observer.observe(element));
  }

  function initScrollTop() {
    const button = document.getElementById('scroll-top');
    if (!button) return;

    window.addEventListener('scroll', () => {
      button.classList.toggle('visible', window.scrollY > 420);
    }, { passive: true });

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initImageZoom() {
    const mainImg = document.querySelector('.product-image-main img');
    if (!mainImg) return;

    let overlay = document.getElementById('zoom-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'zoom-overlay';
      overlay.innerHTML = '<img id="zoom-img" alt="Zoomed product">';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', () => overlay.classList.remove('open'));
    }

    const wrapper = mainImg.closest('.product-image-main');
    if (!wrapper) return;

    wrapper.addEventListener('click', () => {
      const zoomImg = document.getElementById('zoom-img');
      if (!zoomImg) return;
      zoomImg.src = mainImg.currentSrc || mainImg.src;
      overlay.classList.add('open');
    });
  }

  function initSwipeToClose(drawerId, closeFn) {
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;

    let startX = 0;
    let isDragging = false;

    drawer.addEventListener('touchstart', event => {
      startX = event.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    drawer.addEventListener('touchmove', event => {
      if (!isDragging) return;
      const delta = event.touches[0].clientX - startX;
      if (delta > 0) {
        drawer.style.transform = `translateX(${delta}px)`;
        drawer.style.transition = 'none';
      }
    }, { passive: true });

    drawer.addEventListener('touchend', event => {
      if (!isDragging) return;
      isDragging = false;
      const delta = event.changedTouches[0].clientX - startX;
      drawer.style.transform = '';
      drawer.style.transition = '';
      if (delta > 110) closeFn();
    });
  }

  function initCategoryFilter() {
    const pills = document.querySelectorAll('#categories .category-pill, #filter-bar .category-pill');
    if (!pills.length) return;

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const scope = pill.closest('#categories, #filter-bar');
        if (!scope) return;

        scope.querySelectorAll('.category-pill').forEach(item => item.classList.remove('active'));
        pill.classList.add('active');

        // Support both data-category (homepage) and data-tag (collection pages)
        const category = (pill.dataset.category || pill.dataset.tag || 'all').toLowerCase();

        document.querySelectorAll('#products-grid .product-card').forEach(card => {
          if (category === 'all') { card.style.display = ''; return; }
          const cardType   = (card.dataset.category || '').toLowerCase();
          const cardVendor = (card.dataset.vendor   || '').toLowerCase();
          const cardTags   = (card.dataset.tags     || '').toLowerCase();
          const matches = cardType === category
            || cardVendor === category
            || cardVendor.includes(category)
            || cardTags.split(',').some(t => t.trim() === category || t.trim().replace(/\s+/g,'-') === category);
          card.style.display = matches ? '' : 'none';
        });
      });
    });
  }

  function expandSearchQuery(query) {
    const normalized = query.trim().toLowerCase();
    return SEARCH_SYNONYMS[normalized] || normalized;
  }

  function initSearch() {
    const input = document.getElementById('search-input');
    const suggestions = document.getElementById('search-suggestions');
    if (!input || !suggestions) return;

    let debounce;
    let activeIdx = -1;

    input.addEventListener('input', () => {
      clearTimeout(debounce);
      activeIdx = -1;
      debounce = setTimeout(async () => {
        const query = input.value.trim();
        if (query.length < 2) {
          suggestions.classList.remove('active');
          input.setAttribute('aria-expanded', 'false');
          return;
        }

        const requestQuery = expandSearchQuery(query);

        try {
          const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(requestQuery)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`);
          const data = await response.json();
          const items = data.resources?.results?.products || [];

          if (!items.length) {
            suggestions.innerHTML = `
              <div class="suggestion-empty">
                <strong>No direct matches</strong>
                <span>Try broader terms or jump back in with recovery suggestions.</span>
                <div class="empty-state-links">
                  <a href="/search?q=raspberry+pi&type=product">Raspberry Pi</a>
                  <a href="/search?q=arduino+uno&type=product">Arduino Uno</a>
                  <a href="/collections/all">Browse All</a>
                </div>
              </div>
            `;
          } else {
            suggestions.innerHTML = items.map((item, index) => {
              const image = item.featured_image?.url ? `${item.featured_image.url}&width=96` : '';
              return `
              <a class="suggestion-item" href="${item.url}" data-suggestion-index="${index}">
                  ${image ? `<img src="${image}" alt="${escapeHtml(item.title)}" loading="lazy">` : '<div class="suggestion-fallback"></div>'}
                  <div class="suggestion-info">
                    <div class="suggestion-name">${highlight(item.title, query)}</div>
                    <div class="suggestion-category">${escapeHtml(item.product_type || 'Product')}</div>
                  </div>
                </a>
              `;
            }).join('');
          }

          suggestions.classList.add('active');
          input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          console.error('Search error:', error);
        }
      }, 200);
    });

    document.addEventListener('click', event => {
      if (!event.target.closest('#search-container')) {
        suggestions.classList.remove('active');
        input.setAttribute('aria-expanded', 'false');
      }
    });

    input.addEventListener('keydown', event => {
      const items = suggestions.querySelectorAll('.suggestion-item');
      if (!items.length && event.key !== 'Enter') return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        activeIdx = Math.min(activeIdx + 1, items.length - 1);
        toggleActiveSuggestion(items, activeIdx);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        activeIdx = Math.max(activeIdx - 1, 0);
        toggleActiveSuggestion(items, activeIdx);
      } else if (event.key === 'Enter') {
        const query = input.value.trim();
        if (activeIdx >= 0 && items[activeIdx]) {
          window.location.href = items[activeIdx].href;
        } else if (query.length >= 2) {
          window.location.href = `/search?q=${encodeURIComponent(expandSearchQuery(query))}&type=product`;
        }
      } else if (event.key === 'Escape') {
        suggestions.classList.remove('active');
        input.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function toggleActiveSuggestion(items, activeIdx) {
    items.forEach((item, index) => item.classList.toggle('active-suggestion', index === activeIdx));
  }

  function highlight(text, query) {
    if (!query) return escapeHtml(text);
    const safeText = escapeHtml(text);
    const pattern = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig');
    return safeText.replace(pattern, '<strong>$1</strong>');
  }

  function initCart() {
    const cartBtn = document.getElementById('cart-btn');
    const cartClose = document.getElementById('cart-close');
    const cartOverlay = document.getElementById('cart-overlay');
    const continueBtn = document.getElementById('continue-shopping');

    if (cartBtn) cartBtn.addEventListener('click', openCart);
    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
    if (continueBtn) continueBtn.addEventListener('click', event => {
      event.preventDefault();
      closeCart();
    });

    fetchCart();
    initSwipeToClose('cart-drawer', closeCart);
    initCouponField();
  }

  function openCart() {
    document.getElementById('cart-drawer')?.classList.add('open');
    document.getElementById('cart-overlay')?.classList.add('open');
    lockBody(true);
    fetchCart();
  }

  function closeCart() {
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.getElementById('cart-overlay')?.classList.remove('open');
    lockBody(false);
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      cartData = await response.json();
      renderCartUI();
    } catch (error) {
      console.error('Cart fetch error:', error);
    }
  }

  async function addToCart(variantId, qty = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Add to cart failed');
      }

      await fetchCart();
      // Only open the cart drawer on desktop (>768px). On mobile just show toast.
      if (window.innerWidth > 768) {
        openCart();
      }
      showToast('Added to cart', 'success');
    } catch (error) {
      console.error('Add to cart error:', error);
      showToast(error.message || 'Unable to add to cart', 'info');
    }
  }

  async function updateCartItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await fetchCart();
    } catch (error) {
      console.error('Update cart error:', error);
    }
  }

  function renderCartUI() {
    const countEl = document.getElementById('cart-count');
    const itemsEl = document.getElementById('cart-items');
    const emptyEl = document.getElementById('cart-empty');
    const footerEl = document.getElementById('cart-footer');
    const scrollExtrasEl = document.getElementById('cart-scroll-extras');
    const subtotalEl = document.getElementById('cart-subtotal');
    const count = cartData.item_count || 0;
    const total = cartData.total_price || 0;

    if (countEl) {
      countEl.textContent = count;
      countEl.classList.toggle('visible', count > 0);
    }

    if (!itemsEl) return;

    itemsEl.querySelectorAll('.cart-item').forEach(item => item.remove());

    if (count === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
      if (scrollExtrasEl) scrollExtrasEl.style.display = 'none';
      updateCartSummary(0);
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (scrollExtrasEl) scrollExtrasEl.style.display = 'block';
    if (subtotalEl) subtotalEl.textContent = formatMoney(total);

    // Insert new cart items before the scroll-extras div so they appear above it
    const insertBefore = scrollExtrasEl || null;

    (cartData.items || []).forEach(item => {
      const image = item.image ? `${item.image}&width=120` : '';
      const variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>`
        : '';
      const element = document.createElement('div');
      element.className = 'cart-item';
      element.innerHTML = `
        ${image ? `<img src="${image}" alt="${escapeHtml(item.title)}" loading="lazy">` : '<div class="cart-item-fallback"></div>'}
        <div class="cart-item-info">
          <div class="cart-item-name">${escapeHtml(item.product_title)}</div>
          ${variantLine}
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-item-controls">
            <button class="cart-qty-minus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button class="cart-qty-plus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">+</button>
            <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove item">Remove</button>
          </div>
        </div>
      `;
      if (insertBefore) {
        itemsEl.insertBefore(element, insertBefore);
      } else {
        itemsEl.appendChild(element);
      }
    });

    itemsEl.querySelectorAll('.cart-qty-minus').forEach(button => {
      button.addEventListener('click', () => {
        // Read live qty from DOM span (sibling of button), not stale data-qty
        const span = button.nextElementSibling;
        const currentQty = span ? parseInt(span.textContent, 10) : parseInt(button.dataset.qty, 10);
        updateCartItem(button.dataset.key, Math.max(0, currentQty - 1));
      });
    });

    itemsEl.querySelectorAll('.cart-qty-plus').forEach(button => {
      button.addEventListener('click', () => {
        const span = button.previousElementSibling;
        const currentQty = span ? parseInt(span.textContent, 10) : parseInt(button.dataset.qty, 10);
        updateCartItem(button.dataset.key, currentQty + 1);
      });
    });

    itemsEl.querySelectorAll('.cart-item-remove').forEach(button => {
      button.addEventListener('click', () => updateCartItem(button.dataset.key, 0));
    });

    updateCartSummary(total);
  }

  function updateCartSummary(totalCents) {
    const threshold = getNumber(body.dataset.freeShippingThreshold, 999);
    const codLimit = getNumber(body.dataset.codLimit, 2000);
    const codEnabled = body.dataset.codEnabled === 'true';
    const subtotal = (Number(totalCents) || 0) / 100;

    const discountBarEnabled = body.dataset.discountBarEnabled !== 'false';
    const discountThreshold = getNumber(body.dataset.discountThreshold, 2000);
    const discountLabel = body.dataset.discountLabel || '10% off';
    const discountCode = body.dataset.discountCode || 'BOT10';
    const botcoinsEnabled = body.dataset.botcoinsEnabled !== 'false';
    const botcoinsPerRupees = getNumber(body.dataset.botcoinsPerRupees, 100);
    const botcoinsRupeeValue = getNumber(body.dataset.botcoinsRupeeValue, 1);

    const progressCopy = document.getElementById('cart-progress-copy');
    const progressFill = document.getElementById('cart-progress-fill');
    const codNote = document.getElementById('cart-cod-note');
    const secureCopy = document.getElementById('cart-secure-copy');

    if (progressCopy) {
      if (subtotal >= threshold) {
        progressCopy.textContent = 'Free shipping unlocked for this order.';
      } else {
        progressCopy.textContent = `Add ${formatRupees(threshold - subtotal)} more to unlock free shipping.`;
      }
    }

    if (progressFill) {
      const ratio = threshold > 0 ? Math.min((subtotal / threshold) * 100, 100) : 0;
      progressFill.style.width = `${ratio}%`;
    }

    const discountProgressEl = document.getElementById('cart-discount-progress');
    const discountCopy = document.getElementById('cart-discount-copy');
    const discountFill = document.getElementById('cart-discount-fill');

    if (discountProgressEl) {
      discountProgressEl.style.display = discountBarEnabled ? '' : 'none';
    }
    if (discountCopy && discountBarEnabled) {
      if (subtotal >= discountThreshold) {
        discountCopy.textContent = `You qualify for ${discountLabel}! Use code ${discountCode}.`;
      } else {
        discountCopy.textContent = `Spend ${formatRupees(discountThreshold - subtotal)} more to get ${discountLabel}.`;
      }
    }
    if (discountFill && discountBarEnabled) {
      const discountRatio = discountThreshold > 0 ? Math.min((subtotal / discountThreshold) * 100, 100) : 0;
      discountFill.style.width = `${discountRatio}%`;
    }

    const botcoinsNote = document.getElementById('cart-botcoins-note');
    const botcoinsAmount = document.getElementById('cart-botcoins-amount');
    const botcoinsValue = document.getElementById('cart-botcoins-value');
    if (botcoinsNote) botcoinsNote.style.display = botcoinsEnabled ? 'flex' : 'none';
    if (botcoinsEnabled && botcoinsAmount && botcoinsValue) {
      const earned = botcoinsPerRupees > 0 ? Math.floor(subtotal / botcoinsPerRupees) : 0;
      const rupeeValue = earned * botcoinsRupeeValue;
      botcoinsAmount.textContent = earned;
      botcoinsValue.textContent = rupeeValue;
    }

    if (codNote && codEnabled) {
      const note = codNote.querySelector('span');
      if (note) {
        note.textContent = subtotal > codLimit
          ? `COD unavailable above ${formatRupees(codLimit)}. Pay online for faster dispatch.`
          : body.dataset.codMessage || `COD available below ${formatRupees(codLimit)}.`;
      }
    }

    if (secureCopy) secureCopy.textContent = body.dataset.secureCheckoutText || secureCopy.textContent;
  }

  function initCouponField() {
    const input = document.getElementById('coupon-input');
    const applyBtn = document.getElementById('coupon-apply');
    const message = document.getElementById('coupon-message');
    if (!input || !applyBtn || !message) return;

    const storedCoupon = sessionStorage.getItem(COUPON_KEY) || body.dataset.highlightedCoupon;
    if (storedCoupon) {
      input.value = storedCoupon;
      message.textContent = `Saved code ${storedCoupon} will be applied at checkout.`;
    }

    applyBtn.addEventListener('click', () => {
      const code = input.value.trim().toUpperCase();
      if (!code) {
        sessionStorage.removeItem(COUPON_KEY);
        message.textContent = 'Coupon cleared.';
        return;
      }

      sessionStorage.setItem(COUPON_KEY, code);
      message.textContent = `${code} saved. One discount code at a time is supported in this flow.`;
      showToast(`${code} applied for checkout`, 'success');
    });
  }

  // ── Qty-limit popup ──────────────────────────────────────────────────────
  function showQtyLimitModal(message) {
    let modal = document.getElementById('qty-limit-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'qty-limit-modal';
      modal.style.cssText = `
        position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;
        background:rgba(0,0,0,0.45);padding:20px;`;
      modal.innerHTML = `
        <div style="background:#fff;border-radius:18px;padding:28px 24px;max-width:400px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,0.2);">
          <div style="display:flex;gap:12px;align-items:flex-start;margin-bottom:18px;">
            <span style="font-size:28px;">⚠️</span>
            <div>
              <strong id="qty-limit-title" style="font-size:17px;display:block;margin-bottom:6px;color:#111;">Quantity Notice</strong>
              <p id="qty-limit-msg" style="font-size:14px;color:#555;margin:0;line-height:1.5;"></p>
            </div>
          </div>
          <button id="qty-limit-ok" style="width:100%;padding:12px;background:#111;color:#fff;border:none;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;">Got it</button>
        </div>`;
      document.body.appendChild(modal);
      modal.addEventListener('click', e => { if (e.target === modal) modal.style.display = 'none'; });
      document.getElementById('qty-limit-ok').addEventListener('click', () => { modal.style.display = 'none'; });
    }
    document.getElementById('qty-limit-msg').textContent = message;
    modal.style.display = 'flex';
  }

  // Returns max allowed qty based on price in cents (0 = no product price available = no limit)
  function getPriceBasedMaxQty(priceCents) {
    if (!priceCents) return Infinity;
    const price = priceCents / 100; // convert paise → rupees
    const tier2Threshold = getNumber(body.dataset.qtyCapTier2Threshold, 50000);
    const tier2Max = getNumber(body.dataset.qtyCapTier2Max, 10);
    const tier1Threshold = getNumber(body.dataset.qtyCapTier1Threshold, 10000);
    const tier1Max = getNumber(body.dataset.qtyCapTier1Max, 50);
    if (price >= tier2Threshold) return tier2Max;
    if (price >= tier1Threshold) return tier1Max;
    return Infinity;
  }

  function initCartButtons() {
    document.addEventListener('click', async event => {
      const addButton = event.target.closest('[data-add-to-cart]');
      if (!addButton) return;
      event.preventDefault();
      const variantId = addButton.dataset.variantId;
      if (!variantId) return;

      // ── Price-based qty limit check ──
      // Parse pdpData once per click; cache it on the script element itself
      let priceCents = 0;
      let variantData = null;
      const pdpScript = document.querySelector('[id^="ProductJson-"]');
      if (pdpScript) {
        if (!pdpScript._parsed) {
          try { pdpScript._parsed = JSON.parse(pdpScript.textContent); } catch(_) {}
        }
        const pdpData = pdpScript._parsed;
        if (pdpData) {
          variantData = (pdpData.variants || []).find(v => String(v.id) === String(variantId)) || null;
          if (variantData) priceCents = variantData.price;
        }
      }
      if (!priceCents) {
        const card = addButton.closest('[data-price]');
        if (card) priceCents = parseInt(card.dataset.price, 10) || 0;
      }

      const priceMaxQty = getPriceBasedMaxQty(priceCents);

      // Check what's already in cart for this variant
      const existingItem = (cartData.items || []).find(i => String(i.variant_id) === String(variantId));
      const cartQty = existingItem ? existingItem.quantity : 0;

      if (priceMaxQty !== Infinity && cartQty >= priceMaxQty) {
        const priceRupees = priceCents / 100;
        showQtyLimitModal(
          `High-value items (₹${priceRupees.toLocaleString('en-IN')} and above) are limited to ${priceMaxQty} units per order. You already have ${cartQty} in your cart.`
        );
        return;
      }

      // ── Over-stock preorder check ──
      const qtyInput = document.getElementById('qty-hidden');
      const addingQty = qtyInput ? Math.min(parseInt(qtyInput.value, 10) || 1, priceMaxQty === Infinity ? 999 : priceMaxQty - cartQty) : 1;

      if (variantData && variantData.inventory_management && variantData.inventory_quantity > 0) {
        // We have local data — check immediately, no network call needed
        if (cartQty + addingQty > variantData.inventory_quantity) {
          showQtyLimitModal(
            `You're ordering ${cartQty + addingQty} unit(s), but only ${variantData.inventory_quantity} are currently in stock. The extra units will be treated as a pre-order and may take 3–12 weeks to ship.`
          );
        }
        addToCart(variantId, Math.max(1, addingQty));
      } else {
        // Collection card or no PDP data — check Shopify inventory API asynchronously
        // but don't wait for it; add immediately and warn if needed
        addToCart(variantId, Math.max(1, addingQty));
        if (cartQty > 0) {
          // Fetch to check real inventory only when there's already something in cart
          fetch(`/variants/${variantId}.js`)
            .then(r => r.json())
            .then(v => {
              if (v.inventory_management && v.inventory_quantity > 0 && cartQty + addingQty > v.inventory_quantity) {
                showQtyLimitModal(
                  `You're ordering ${cartQty + addingQty} unit(s), but only ${v.inventory_quantity} are currently in stock. The extra units will be treated as a pre-order and may take 3–12 weeks to ship.`
                );
              }
            }).catch(() => {});
        }
      }
    });

    const buyNowBtn = document.getElementById('detail-buy-now');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', () => {
        const variantInput = document.getElementById('selected-variant');
        const qtyInput = document.getElementById('qty-hidden');
        if (!variantInput) return;
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        window.location.href = `/cart/${variantInput.value}:${quantity}?checkout`;
      });
    }

    document.querySelectorAll('[data-checkout-trigger]').forEach(trigger => {
      trigger.addEventListener('click', event => {
        if (trigger.tagName === 'A') event.preventDefault();

        // 3D print orders (identified by the "3D File" line item property) need a
        // pincode-based pickup/delivery decision before payment, so send those
        // through our own review page first instead of straight to checkout.
        if (cartHasPrintItem()) {
          window.location.href = '/pages/3d-print-checkout';
          return;
        }

        const code = sessionStorage.getItem(COUPON_KEY);
        if (code) {
          window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
          return;
        }
        window.location.href = '/checkout';
      });
    });
  }

  function cartHasPrintItem() {
    return (cartData.items || []).some(item =>
      item.properties && Object.keys(item.properties).some(key => key === '3D File')
    );
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  }

  function isWishlisted(handle) {
    return getWishlist().some(item => item.handle === handle);
  }

  function getWishlistKey(button) {
    const handle = button.dataset.productHandle;
    const variantId = button.dataset.productVariantId;
    return variantId ? `${handle}__${variantId}` : handle;
  }

  function uniqueWishlist(items) {
    const seen = new Set();
    return items.filter(item => {
      if (!item?.handle || seen.has(item.handle)) return false;
      seen.add(item.handle);
      return true;
    });
  }

  async function syncWishlistToAccount(items) {
    const customerId = body.dataset.customerId;
    if (!customerId || wishlistSyncInFlight) return;

    const proxyPath = body.dataset.wishlistProxyPath;
    // Prefer app proxy if configured; otherwise use Shopify metafield write via note_attributes trick
    if (proxyPath) {
      wishlistSyncInFlight = true;
      try {
        await fetch(proxyPath, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
      } catch (e) {
        console.warn('Wishlist proxy sync failed:', e);
      } finally {
        wishlistSyncInFlight = false;
      }
      return;
    }

    // Fallback: store in customer account note via /account endpoint (no API key needed)
    wishlistSyncInFlight = true;
    try {
      const handles = items.map(i => i.handle).join(',');
      const formData = new FormData();
      formData.append('customer[note]', `wishlist:${handles}`);
      await fetch('/account', { method: 'POST', body: formData });
    } catch (e) {
      console.warn('Wishlist account sync failed:', e);
    } finally {
      wishlistSyncInFlight = false;
    }
  }

  async function hydrateWishlistFromRemote() {
    const proxyPath = body.dataset.wishlistProxyPath;
    const customerId = body.dataset.customerId;
    if (!customerId) return;

    if (proxyPath) {
      try {
        const response = await fetch(proxyPath, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        const merged = uniqueWishlist([...(data.items || []), ...getWishlist()]);
        saveWishlist(merged);
      } catch (error) {
        console.warn('Remote wishlist unavailable:', error);
      }
    }
    // Note: localStorage already has data from previous sessions on this device
  }

  function toggleWishlistItem(item) {
    const list = getWishlist();
    const index = list.findIndex(entry => entry.handle === item.handle);
    if (index > -1) {
      list.splice(index, 1);
      showToast('Removed from wishlist', 'info');
    } else {
      list.push(item);
      showToast('Saved to wishlist', 'success');
    }

    const unique = uniqueWishlist(list);
    saveWishlist(unique);
    renderWishlistUI();
    syncHeartButtons();
    syncWishlistToAccount(unique);
  }

  function openWishlist() {
    document.getElementById('wishlist-drawer')?.classList.add('open');
    document.getElementById('wishlist-overlay')?.classList.add('open');
    lockBody(true);
    renderWishlistUI();
  }

  function closeWishlist() {
    document.getElementById('wishlist-drawer')?.classList.remove('open');
    document.getElementById('wishlist-overlay')?.classList.remove('open');
    lockBody(false);
  }

  function renderWishlistUI() {
    const items = getWishlist();
    const countEl = document.getElementById('wishlist-count');
    const itemsEl = document.getElementById('wishlist-items');
    const emptyEl = document.getElementById('wishlist-empty');
    const footerEl = document.getElementById('wishlist-footer');

    if (countEl) {
      countEl.textContent = items.length;
      countEl.classList.toggle('visible', items.length > 0);
    }

    if (!itemsEl) return;

    itemsEl.querySelectorAll('.wishlist-item').forEach(item => item.remove());

    if (!items.length) {
      if (emptyEl) emptyEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';

    items.forEach(item => {
      const priceText = typeof item.price === 'string' && /[^\d.,\s]/.test(item.price)
        ? item.price
        : formatRupees(getNumber(item.price, 0));
      const card = document.createElement('div');
      card.className = 'wishlist-item';
      card.innerHTML = `
        ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">` : '<div class="wishlist-image-fallback"></div>'}
        <div class="wishlist-item-info">
          <div class="wishlist-item-name">${escapeHtml(item.title)}</div>
          <div class="wishlist-item-price">${priceText}</div>
          <div class="wishlist-item-actions">
            <a href="${item.url}">View Product</a>
            <button class="wishlist-item-remove" data-handle="${item.handle}">Remove</button>
          </div>
        </div>
      `;
      itemsEl.appendChild(card);
    });

    itemsEl.querySelectorAll('.wishlist-item-remove').forEach(button => {
      button.addEventListener('click', () => {
        const nextItems = getWishlist().filter(item => item.handle !== button.dataset.handle);
        saveWishlist(nextItems);
        renderWishlistUI();
        syncHeartButtons();
        syncWishlistToAccount(nextItems);
      });
    });
  }

  function syncHeartButtons() {
    document.querySelectorAll('[data-wishlist-add]').forEach(button => {
      const key = getWishlistKey(button);
      button.classList.toggle('wishlisted', getWishlist().some(item => item.handle === key));
    });
  }

  async function initWishlist() {
    await hydrateWishlistFromRemote();

    const wishlistBtn = document.getElementById('wishlist-btn');
    const wishlistClose = document.getElementById('wishlist-close');
    const wishlistOverlay = document.getElementById('wishlist-overlay');

    if (wishlistBtn) wishlistBtn.addEventListener('click', openWishlist);
    if (wishlistClose) wishlistClose.addEventListener('click', closeWishlist);
    if (wishlistOverlay) wishlistOverlay.addEventListener('click', closeWishlist);

    document.addEventListener('click', event => {
      const button = event.target.closest('[data-wishlist-add]');
      if (!button) return;
      event.preventDefault();
      const key = getWishlistKey(button);
      const variantTitle = button.dataset.productVariantTitle;
      const displayTitle = (variantTitle && variantTitle !== 'Default Title')
        ? `${button.dataset.productTitle} – ${variantTitle}`
        : button.dataset.productTitle;
      toggleWishlistItem({
        handle: key,
        title: displayTitle,
        url: button.dataset.productUrl,
        price: button.dataset.productPrice,
        image: button.dataset.productImage
      });
    });

    renderWishlistUI();
    syncHeartButtons();
    initSwipeToClose('wishlist-drawer', closeWishlist);
  }

  function computeVariantStockLabel(variant, stockLabelOverride) {
    if (stockLabelOverride) return stockLabelOverride;
    if (!variant) return 'Unavailable';
    if (!variant.available) return 'Out of stock';
    if (variant.inventory_management && Number(variant.inventory_quantity) > 0) {
      return Number(variant.inventory_quantity) <= 5 ? 'Low stock' : 'In stock';
    }
    if (variant.inventory_policy === 'continue') return 'Back-order';
    return 'In stock';
  }

  function initProductPage() {
    const productScript = document.querySelector('[id^="ProductJson-"]');
    if (!productScript) return;

    const metaScript = document.querySelector('[id^="ProductMeta-"]');
    const productData = JSON.parse(productScript.textContent);
    const meta = metaScript ? JSON.parse(metaScript.textContent) : {};

    // --- DOM references ---
    const variantSelectors  = document.getElementById('variant-selectors');
    const variantInput      = document.getElementById('selected-variant');
    const qtyMinus          = document.getElementById('qty-minus');
    const qtyPlus           = document.getElementById('qty-plus');
    const qtyValue          = document.getElementById('qty-value');
    const qtyHidden         = document.getElementById('qty-hidden');
    const priceEl           = document.getElementById('product-price');
    const comparePriceEl    = document.getElementById('product-compare-price');
    const stockLabelEl      = document.getElementById('product-stock-label');
    const addToCartBtn      = document.getElementById('detail-add-to-cart');
    const buyNowBtn         = document.getElementById('detail-buy-now');
    const mobileBar         = document.getElementById('mobile-purchase-bar');
    const mobileAdd         = document.getElementById('mobile-add-to-cart');
    const mobilePrice       = document.getElementById('mobile-price');
    const mobileStock       = document.getElementById('mobile-stock');
    const mainImage         = document.querySelector('.product-image-main img');
    const botcoinsAmountEl  = document.getElementById('pdp-botcoins-amount');
    const botcoinsBanner    = document.getElementById('product-botcoins-banner');

    // Option groups from the variant-selectors container
    const optionGroups = variantSelectors
      ? Array.from(variantSelectors.querySelectorAll('.option-group'))
      : [];

    let quantity = parseInt(qtyHidden?.value || '1', 10);
    let maxQty = Infinity; // updated per variant when inventory is tracked

    // Derive initial selected options from active pills (or first variant fallback)
    let selectedOptions = optionGroups.map((group, idx) => {
      const active = group.querySelector('.category-pill.active');
      return active ? active.dataset.value : (productData.variants[0]?.options[idx] ?? null);
    });

    // --- Helpers ---
    function updateQuantity(nextQty) {
      quantity = Math.min(Math.max(1, nextQty), maxQty);
      if (qtyValue) { qtyValue.textContent = String(quantity); qtyValue.dataset.qty = String(quantity); }
      if (qtyHidden) qtyHidden.value = String(quantity);
      // Disable + when at cap
      if (qtyPlus) qtyPlus.disabled = (quantity >= maxQty);
      if (qtyMinus) qtyMinus.disabled = (quantity <= 1);
    }

    function findVariant() {
      return productData.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      ) || productData.variants[0];
    }

    function computeStockLabel(variant) {
      if (meta.stockLabelOverride) return { label: meta.stockLabelOverride, tier: 'in-stock', qty: null };
      if (!variant) return { label: 'Unavailable', tier: 'soldout', qty: null };
      if (!variant.available) return { label: 'Out of stock', tier: 'soldout', qty: 0 };

      if (variant.inventory_management && Number.isFinite(Number(variant.inventory_quantity))) {
        const qty = Number(variant.inventory_quantity);
        if (qty <= 0) return { label: 'Out of stock', tier: 'soldout', qty: 0 };
        if (qty < 3)  return { label: `Only ${qty} left!`, tier: 'critical', qty };
        if (qty < 10) return { label: `Low stock · ${qty} left`, tier: 'low', qty };
        return { label: `In stock · ${qty} available`, tier: 'in-stock', qty };
      }

      if (variant.inventory_policy === 'continue') return { label: 'Back-order available', tier: 'in-stock', qty: null };
      return { label: 'In stock', tier: 'in-stock', qty: null };
    }

    function updateBotcoins(priceCents) {
      if (!botcoinsAmountEl) return;
      const botcoinsPerRupees = getNumber(body.dataset.botcoinsPerRupees, 100);
      const botcoinsRupeeValue = getNumber(body.dataset.botcoinsRupeeValue, 1);
      const priceRupees = (Number(priceCents) || 0) / 100;
      const earned = botcoinsPerRupees > 0 ? Math.floor(priceRupees / botcoinsPerRupees) : 0;
      botcoinsAmountEl.textContent = earned;
      const rupeeEl = document.getElementById('pdp-botcoins-rupees');
      if (rupeeEl) rupeeEl.textContent = earned * botcoinsRupeeValue;
    }

    function updateVariantUI() {
      const variant = findVariant();
      if (!variant) return;

      // Hidden input + URL
      if (variantInput) variantInput.value = variant.id;
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (_) {}

      // Price
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.classList.remove('is-hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.classList.add('is-hidden');
        }
      }

      // Botcoins banner
      updateBotcoins(variant.price);

      // Stock label + quantity cap
      const { label: stockLabel, tier, qty: stockQty } = computeStockLabel(variant);

      // Update maxQty from stock tier AND price limit
      const priceLimit = getPriceBasedMaxQty(variant.price);
      if (stockQty !== null && stockQty > 0) {
        maxQty = Math.min(stockQty, priceLimit);
      } else if (stockQty === 0) {
        maxQty = 0;
      } else {
        maxQty = priceLimit;
      }

      // Clamp current qty to new maxQty
      updateQuantity(Math.min(quantity, maxQty === 0 ? 1 : maxQty));

      // Apply tier class to stock pill
      if (stockLabelEl) {
        stockLabelEl.textContent = stockLabel;
        stockLabelEl.className = 'stock-pill stock-pill--' + tier;
      }

      // Out-of-stock inline note / back-order / notify me
      let inlineNote = document.getElementById('variant-stock-note');
      if (!inlineNote) {
        inlineNote = document.createElement('div');
        inlineNote.id = 'variant-stock-note';
        inlineNote.className = 'product-inline-note';
        const actionsDiv = document.querySelector('.detail-actions');
        if (actionsDiv) actionsDiv.parentNode.insertBefore(inlineNote, actionsDiv);
      }
      const isPreorder = variant.inventory_management && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue';
      const canBuy = variant.available;

      if (!variant.available && !isPreorder) {
        inlineNote.style.display = 'block';
        inlineNote.innerHTML = `
          <strong>This variant is currently out of stock.</strong>
          <div style="margin-top:8px;display:flex;gap:10px;flex-wrap:wrap;">
            <a href="/pages/contact?subject=Back+order+request&body=I+am+interested+in+${encodeURIComponent(productData.title)}" class="btn-ghost" style="font-size:13px;padding:8px 16px;">Request Back Order</a>
            <a href="/pages/contact?subject=Notify+me&body=Please+notify+me+when+${encodeURIComponent(productData.title)}+is+back+in+stock" class="btn-primary" style="font-size:13px;padding:8px 16px;">Notify Me When Back</a>
          </div>`;
      } else {
        inlineNote.style.display = 'none';
        inlineNote.innerHTML = '';
      }

      // Add to Cart & Buy Now buttons
      if (addToCartBtn) {
        addToCartBtn.disabled = !canBuy;
        if (isPreorder) {
          addToCartBtn.textContent = 'Pre-Order Now';
          addToCartBtn.classList.add('btn-preorder');
        } else {
          addToCartBtn.textContent = canBuy ? 'Add to Cart' : 'Out of Stock';
          addToCartBtn.classList.remove('btn-preorder');
        }
        addToCartBtn.dataset.variantId = variant.id;
      }
      if (buyNowBtn) {
        buyNowBtn.disabled = !canBuy;
        if (isPreorder) {
          buyNowBtn.style.display = 'none';
        } else {
          buyNowBtn.style.display = '';
        }
      }

      // Update preorder warning visibility
      const preorderWarning = document.getElementById('preorder-warning');
      if (preorderWarning) {
        preorderWarning.style.display = isPreorder ? 'flex' : 'none';
      }

      // Mobile purchase bar
      if (mobileBar && mobileAdd && mobilePrice && mobileStock) {
        mobilePrice.textContent = formatMoney(variant.price);
        mobileStock.textContent = stockLabel;
        mobileStock.className = 'mobile-stock-badge stock-pill--' + tier;
        mobileAdd.disabled = !canBuy;
        mobileAdd.dataset.variantId = variant.id;
        if (isPreorder && !variant.available) {
          mobileAdd.textContent = 'Pre-Order Now';
        } else {
          mobileAdd.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';
        }
      }

      // Variant image — strip srcset so browser doesn't ignore src
      if (mainImage && variant.featured_image) {
        const imgSrc = variant.featured_image.src || variant.featured_image.url;
        if (imgSrc && mainImage.src !== imgSrc) {
          mainImage.style.transition = 'opacity 0.15s ease';
          mainImage.style.opacity = '0';
          requestAnimationFrame(() => {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = imgSrc;
            mainImage.onload = () => { mainImage.style.opacity = '1'; };
            if (mainImage.complete) mainImage.style.opacity = '1';
          });
          const matchThumb = document.querySelector(`#product-thumbs .product-thumb[data-image-url*="${imgSrc.split('?')[0].split('/').pop().split('_')[0]}"]`);
          if (matchThumb) {
            document.querySelectorAll('#product-thumbs .product-thumb').forEach(t => t.classList.remove('active'));
            matchThumb.classList.add('active');
          }
        }
      }

      // Sync PDP wishlist heart to current variant
      const pdpHeart = document.querySelector('.pdp-wishlist-heart[data-wishlist-add]');
      if (pdpHeart) {
        pdpHeart.dataset.productVariantId = variant.id;
        pdpHeart.dataset.productVariantTitle = variant.title || '';
        pdpHeart.dataset.productPrice = String(Math.round((variant.price || 0) / 100));
        pdpHeart.dataset.productUrl = `${productData.url || window.location.pathname}?variant=${variant.id}`;
        const heartKey = `${pdpHeart.dataset.productHandle}__${variant.id}`;
        pdpHeart.classList.toggle('wishlisted', getWishlist().some(item => item.handle === heartKey));
      }
    }

    // --- Option pill clicks with linked-options support ---
    if (variantSelectors) {
      variantSelectors.addEventListener('click', e => {
        const pill = e.target.closest('.category-pill');
        if (!pill) return;

        const group = pill.closest('.option-group');
        if (!group) return;

        group.querySelectorAll('.category-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');

        selectedOptions = optionGroups.map(g => {
          const a = g.querySelector('.category-pill.active');
          return a ? a.dataset.value : null;
        });

        let matched = productData.variants.find(v =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );

        if (!matched) {
          const clickedGroupIndex = optionGroups.indexOf(group);
          const clickedValue = pill.dataset.value;

          matched =
            productData.variants.find(v => v.options[clickedGroupIndex] === clickedValue && v.available) ||
            productData.variants.find(v => v.options[clickedGroupIndex] === clickedValue);

          if (matched) {
            selectedOptions = [...matched.options];
            optionGroups.forEach((g, idx) => {
              if (idx === clickedGroupIndex) return;
              const correctValue = matched.options[idx];
              g.querySelectorAll('.category-pill').forEach(p => p.classList.remove('active'));
              const correctPill = g.querySelector(`.category-pill[data-value="${CSS.escape(correctValue)}"]`);
              if (correctPill) correctPill.classList.add('active');
            });
          }
        }

        if (matched) selectedOptions = [...matched.options];
        updateVariantUI();
      });
    }

    // --- Quantity controls ---
    if (qtyMinus) qtyMinus.addEventListener('click', () => updateQuantity(quantity - 1));
    if (qtyPlus)  qtyPlus.addEventListener('click',  () => updateQuantity(quantity + 1));

    // --- Add to Cart ---
    // NOTE: handled by the delegated [data-add-to-cart] listener in initCartButtons.
    // Do NOT add a second handler here — it causes double-add.

    // --- Mobile Add to Cart ---
    // Also handled by the delegated listener via data-add-to-cart on the mobile button.

    // --- Init ---
    updateQuantity(quantity);
    updateVariantUI();
    saveRecentlyViewed(productData, findVariant());
  }

  function getRecentViewed() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveRecentlyViewed(productData, variant) {
    const image = document.querySelector('.product-image-main img');
    const list = getRecentViewed().filter(item => item.handle !== productData.handle);
    list.unshift({
      handle: productData.handle,
      title: productData.title,
      url: `/products/${productData.handle}`,
      image: image ? (image.currentSrc || image.src) : '',
      price: formatMoney(variant?.price || productData.price || 0)
    });
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 10)));
  }

  function initRecentlyViewed() {
    const section = document.getElementById('recently-viewed-section');
    const grid = document.getElementById('recently-viewed-grid');
    if (!section || !grid) return;

    const currentHandle = window.location.pathname.split('/').pop().split('?')[0];
    const items = getRecentViewed().filter(item => item.handle !== currentHandle).slice(0, 8);
    if (!items.length) return;

    grid.innerHTML = items.map(item => `
      <article class="product-card">
        <a href="${item.url}" class="card-image-link">
          <div class="card-image">
            ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy" class="card-img">` : '<div class="suggestion-fallback"></div>'}
          </div>
        </a>
        <div class="card-body">
          <div class="card-name"><a href="${item.url}" style="color:inherit;">${escapeHtml(item.title)}</a></div>
          <div class="card-price">${item.price}</div>
          <div class="card-actions" style="margin-top:12px;">
            <a href="${item.url}" class="btn-black" style="padding:6px 12px;font-size:12px;">View</a>
          </div>
        </div>
      </article>
    `).join('');

    section.removeAttribute('hidden');
    setTimeout(updateScrollButtons, 50);
  }
  function initThumbnails() {
    const thumbs = document.querySelectorAll('#product-thumbs .product-thumb');
    const mainImage = document.querySelector('.product-image-main img');
    if (!thumbs.length || !mainImage) return;

    // Preload all gallery images immediately so switching is instant
    thumbs.forEach(thumb => {
      const url = thumb.dataset.imageUrl;
      if (url && url !== mainImage.src) {
        const img = new Image();
        img.src = url;
      }
    });

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        const newSrc = thumb.dataset.imageUrl;
        // Crossfade: fade out → swap src → fade in
        mainImage.style.transition = 'opacity 0.15s ease';
        mainImage.style.opacity = '0';
        // Use requestAnimationFrame to ensure the fade-out frame paints first
        requestAnimationFrame(() => {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = newSrc;
          mainImage.alt = thumb.dataset.imageAlt || '';
          mainImage.onload = () => { mainImage.style.opacity = '1'; };
          // Fallback in case image is already cached and onload doesn't fire
          if (mainImage.complete) mainImage.style.opacity = '1';
        });
      });
    });
  }

  // initVariantSelector is intentionally removed.
  // All variant logic (price, stock, linked options, mobile bar) lives in initProductPage below.

  function initMobileSearchToggle() {
    const toggle = document.getElementById('search-toggle');
    const container = document.getElementById('search-container');
    if (!toggle || !container) return;

    toggle.addEventListener('click', () => {
      container.classList.toggle('mobile-open');
      const input = container.querySelector('.search-bar');
      if (input && container.classList.contains('mobile-open')) {
        input.focus();
      }
    });

    document.addEventListener('click', event => {
      if (!event.target.closest('#search-container') && !event.target.closest('#search-toggle')) {
        container.classList.remove('mobile-open');
      }
    });
  }

  function initRecommendations() {
    const productRecommendationsSection = document.querySelector('product-recommendations');
    if (!productRecommendationsSection) return;

    fetch(productRecommendationsSection.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error('Error fetching recommendations', e);
      });
  }

  function initViewToggle() {
    const gridBtn = document.getElementById('btn-view-grid');
    const listBtn = document.getElementById('btn-view-list');
    const productsGrid = document.getElementById('products-grid');

    if (!gridBtn || !listBtn || !productsGrid) return;

    // Load saved preference
    const savedView = localStorage.getItem('buildabot_collection_view');
    if (savedView === 'list') {
      productsGrid.classList.add('list-view');
      gridBtn.classList.remove('active');
      listBtn.classList.add('active');
    }

    gridBtn.addEventListener('click', () => {
      productsGrid.classList.remove('list-view');
      gridBtn.classList.add('active');
      listBtn.classList.remove('active');
      localStorage.setItem('buildabot_collection_view', 'grid');
    });

    listBtn.addEventListener('click', () => {
      productsGrid.classList.add('list-view');
      listBtn.classList.add('active');
      gridBtn.classList.remove('active');
      localStorage.setItem('buildabot_collection_view', 'list');
    });
  }

  function updateScrollButtons() {
    document.querySelectorAll('.scroll-row-container').forEach(container => {
      const row = container.querySelector('.scroll-row');
      const btns = container.querySelectorAll('.scroll-btn');
      if (!row || !btns.length) return;
      if (row.scrollWidth > row.clientWidth + 5) {
        btns.forEach(btn => btn.classList.add('show'));
      } else {
        btns.forEach(btn => btn.classList.remove('show'));
      }
    });
  }

  function initScrollRows() {
    document.querySelectorAll('.scroll-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.scrollTarget;
        const dir = parseInt(btn.dataset.dir, 10);
        const row = document.getElementById(targetId);
        if (!row) return;
        const cardWidth = row.querySelector('.product-card')?.offsetWidth || 260;
        row.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
      });
    });
    window.addEventListener('resize', updateScrollButtons);
    // Initial check
    setTimeout(updateScrollButtons, 100);
  }
})();
